const drvDesktopQuery = window.matchMedia('(min-width: 750px)');
const DRV_SLIDE = '.announcement-bar__slide';

function drvSlideAllowed(slide) {
  const device = slide.dataset.drvDevice;
  if (device === 'mobile' && drvDesktopQuery.matches) return false;
  if (device === 'desktop' && !drvDesktopQuery.matches) return false;
  const referrer = slide.dataset.drvReferrer;
  if (referrer && !document.referrer.includes(referrer)) return false;
  return true;
}

function drvShowOne(bar, keep) {
  const slides = [...bar.querySelectorAll(DRV_SLIDE)];
  if (!slides.length) return;
  let shown = keep && slides.includes(keep) ? keep : slides.find((slide) => slide.getAttribute('aria-hidden') === 'false');
  if (!shown) shown = slides[0];
  for (const slide of slides) {
    const hidden = String(slide !== shown);
    if (slide.getAttribute('aria-hidden') !== hidden) slide.setAttribute('aria-hidden', hidden);
  }
}

function drvFilterAnnouncements() {
  for (const bar of document.querySelectorAll('.drv-announcement announcement-bar-component')) {
    if (!window.Shopify?.designMode) {
      for (const slide of bar.querySelectorAll(DRV_SLIDE)) {
        if (!drvSlideAllowed(slide)) slide.remove();
      }
      const slides = bar.querySelectorAll(DRV_SLIDE);
      if (slides.length <= 1) {
        bar.removeAttribute('autoplay');
        bar.querySelector('slideshow-arrows')?.remove();
        bar.querySelector('drv-announcement-counter')?.remove();
      }
    }
    drvShowOne(bar);
  }
}

drvFilterAnnouncements();

function drvBarFor(target) {
  if (!(target instanceof Element)) return null;
  return target.closest('.drv-announcement')?.querySelector('announcement-bar-component') ?? null;
}

document.addEventListener('shopify:section:load', (event) => {
  if (drvBarFor(event.target) || event.target.querySelector?.('.drv-announcement')) drvFilterAnnouncements();
});

document.addEventListener('shopify:block:select', (event) => {
  const bar = drvBarFor(event.target);
  const slide = event.target.closest?.(DRV_SLIDE);
  if (!bar || !slide) return;
  bar.suspend?.();
  drvShowOne(bar, slide);
});

document.addEventListener('shopify:block:deselect', (event) => {
  drvBarFor(event.target)?.resume?.();
});

class DrvAnnouncementCounter extends HTMLElement {
  #observer;

  connectedCallback() {
    const bar = this.closest('announcement-bar-component');
    const slides = bar?.querySelector('.announcement-bar__slides');
    if (!bar || !slides) return;
    this.#observer = new MutationObserver((records) => {
      if (records.some((record) => record.type === 'childList')) drvShowOne(bar);
      this.#update();
    });
    this.#observer.observe(slides, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
    this.#update();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #update() {
    const bar = this.closest('announcement-bar-component');
    if (!bar) return;
    const slides = [...bar.querySelectorAll(DRV_SLIDE)];
    const index = slides.findIndex((slide) => slide.getAttribute('aria-hidden') !== 'true');
    if (index >= 0) this.textContent = `${index + 1}/${slides.length}`;
  }
}

if (!customElements.get('drv-announcement-counter')) {
  customElements.define('drv-announcement-counter', DrvAnnouncementCounter);
}
